export interface Permission {
  id: number;
  name: string;
  description: string;
  module: string;
  action: 'read' | 'write' | 'delete';
}

export interface Role {
  id: number;
  name: string;
  description: string;
  permissions: Permission[];
  createdAt?: Date;
  updatedAt?: Date;
}

// Roles predefinidos del sistema
export enum RoleType {
  ADMIN = 'Administrador',
  PRODUCTION = 'Producción',
  SALES = 'Ventas',
  PURCHASES = 'Compras',
  CASHIER = 'Caja',
  SUPERVISOR = 'Supervisor',
  SUPPORT = 'Soporte'
}

// Módulos del sistema
export enum SystemModule {
  DASHBOARD = 'dashboard',
  CLIENTS = 'clientes',
  PRODUCTS = 'productos',
  SALES = 'ventas',
  PURCHASES = 'compras',
  CASH = 'caja',
  PRODUCTION = 'produccion',
  STOCK = 'stock',
  REPORTS = 'reportes',
  SETTINGS = 'settings',
  HELP = 'ayuda',
  USER_MANAGEMENT = 'gestion-usuarios'
}

// Acciones posibles
export enum PermissionAction {
  READ = 'read',
  WRITE = 'write',
  DELETE = 'delete'
}